import React from 'react';
import { BottomNavigation, BottomNavigationAction, Paper, Badge } from '@mui/material';
import {
  Dashboard as DashboardIcon,
  People as PeopleIcon,
  Assignment as AssignmentIcon,
  Menu as MenuIcon,
  List as ListIcon,
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';

function MobileBottomNavigation({ appMode, onMenuClick, items }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = path => {
    navigate(path);
  };

  const defaultItems = [
    // Hospital mode: Worklist → /patient-management
    // ASC mode: Dashboard → /asc/dashboard (unchanged)
    appMode === 'asc' ? {
      label: 'Dashboard',
      value: 'dashboard',
      icon: <DashboardIcon />,
      path: '/asc/dashboard',
    } : {
      label: 'Worklist',
      value: 'worklist',
      icon: <ListIcon />,
      path: '/patient-management',
    },
    {
      label: 'Patients',
      value: 'patients',
      icon: <PeopleIcon />,
      path: appMode === 'asc' ? '/asc/patient-management' : '/patient-management',
    },
    {
      label: 'Protocols',
      value: 'protocols',
      icon: <AssignmentIcon />,
      path: appMode === 'asc' ? '/asc/protocol-management' : '/protocols',
    },
    {
      label: 'Menu',
      value: 'menu',
      icon: <MenuIcon />,
      action: onMenuClick,
    },
  ];

  const navigationItems = Array.isArray(items) && items.length > 0 ? items : defaultItems;

  const activeTab = (() => {
    const path = location.pathname;
    const matchItem = navigationItems.find(item => {
      if (typeof item.match === 'function') return item.match(path);
      if (!item.path) return false;
      return path === item.path || path.startsWith(`${item.path}/`);
    });
    return matchItem?.value || navigationItems[0]?.value || 'menu';
  })();

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        display: { xs: 'block', md: 'none' },
        zIndex: theme => theme.zIndex.appBar + 1,
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
      elevation={8}
    >
      <BottomNavigation
        value={activeTab}
        showLabels
        sx={{
          height: 64,
          '& .MuiBottomNavigationAction-root': {
            minWidth: 'auto',
            padding: '6px 0 8px',
            '&.Mui-selected': {
              color: 'primary.main',
            },
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '0.75rem',
            '&.Mui-selected': {
              fontSize: '0.75rem',
            },
          },
        }}
      >
        {navigationItems.map(item => (
          <BottomNavigationAction
            key={item.value}
            label={item.label}
            value={item.value}
            icon={item.icon}
            onClick={() => {
              if (item.action) {
                item.action();
              } else {
                handleNavigation(item.path);
              }
            }}
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
}

export default MobileBottomNavigation;
